import React from 'react'
import ExpandButton from '../expandButton'
import { FormatUtcDateAsLocal } from '../../../../../../helpers/datetime'
import { PoolRestaurantsUpdated } from '../../../../../../components/badges'
import PropTypes from "prop-types"

class RestaurantsUpdated extends React.Component {

  constructor(props) {
    super(props)
    this.state = { isExpanded: false }

    this.toggleExpand = this.toggleExpand.bind(this)
  }

  toggleExpand() {
    this.setState(prevState => ({
      isExpanded: !prevState.isExpanded
    }))
  }

  render() {
    let payload = JSON.parse(this.props.item.payload)

    let table = <table className="table table-striped restaurantsUpdated">
      <thead>
        <tr>
          <th>Added</th>
          <th>Removed</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <ul>
              {payload.Added.map((item) => {
                return <li key={item.Id}>
                  {item.Name}
                </li>
              })}
            </ul>
          </td>
          <td>
            <ul>
              {payload.Removed.map((item) => {
                return <li key={item.Id}>
                  {item.Name}
                </li>
              })}
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    let event = <div>
      <span>
        {payload.Added.length + payload.Removed.length} restaurants added/removed
      </span>
      {this.props.showData && table}
    </div>

    return <tr>
      <td><PoolRestaurantsUpdated text={'Pool Restaurants Updated'} />  <ExpandButton isExpanded={this.state.isExpanded} onClick={this.toggleExpand} /></td>
      <td> {!this.state.isExpanded && event}
        {this.state.isExpanded && table}</td>
      <td>{FormatUtcDateAsLocal(this.props.item.createdUtc)}</td>
      <td>{this.props.item.createdBy}</td>
    </tr>
  }
}

RestaurantsUpdated.propTypes = {
  item: PropTypes.shape({
    payload: PropTypes.string.isRequired,
    createdUtc: PropTypes.string,
    createdBy: PropTypes.string
  }).isRequired,
  showData: PropTypes.bool
}

export default RestaurantsUpdated


// WEBPACK FOOTER //
// ./src/containers/pools/details/logs/components/restaurantsUpdated/index.js